import React, { useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { Stack } from "@mui/material";

const ExpandableAccordion = ({
  title,
  subtitle,
  children,
  titleIcon,
  titleStyle,
  AccordionSummaryStyle,
  rightIcon,
  onRightIconClick,
  isExpanded = false,
  childrenStyle = {},
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const handleToggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion
      sx={{
        boxShadow: "none", // Remove elevation
        border: "none", // Remove border
        "&:before": {
          display: "none", // Remove the default MUI divider
        },
        flex:1
      }}
      expanded={expanded}
      onChange={handleToggleExpand}
    >
      <AccordionSummary
        disableGutters={true}
        sx={{
          ...AccordionSummaryStyle,

          "&.Mui-expanded": {
            minHeight: "40px !important", // Keep expanded state height the same
            margin: 0, // Remove extra margin
            alignItems: "center", // Align items vertically
          },
          "& .MuiAccordionSummary-content": {
            margin: 0, // Reset margin
            alignItems: "center", // Align items vertically
          },
        }}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div
          style={{ display: "flex", alignItems: "flex-start", width: "100%" }}
        >
          <IconButton
            size="small"
            aria-label="show more"
            sx={{ py: 0, px: 0, marginRight: 1 }}
          >
            {expanded ? <ArrowDropDownIcon /> : <ArrowRightIcon />}
          </IconButton>
          <Stack direction="column" spacing={0}>
            <Stack direction={"row"} gap={1} alignItems={"center"}>
              {titleIcon && (
                <img
                  alt="lockIcon"
                  src={titleIcon}
                  style={{ height: "16px", width: "16px" }}
                />
              )}
              <Typography
                variant="h5"
                style={{
                  fontFamily: "DM Sans",
                  fontWeight: 500,
                  fontSize: "16px",
                  lineHeight: "20px",
                  ...titleStyle,
                }}
              >
                {title}
              </Typography>
            </Stack>
            {subtitle && (
              <Typography
                variant="caption"
                style={{
                  fontFamily: "DM Sans",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  color: "#565556",
                  textAlign: "left",
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Stack>
        </div>
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0, ...childrenStyle }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandableAccordion;
